(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info/' + location.hostname).then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        //TODO enable
                        //response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;

                        //JMR-SIGN Properties
                        response.accountId = result.data.accountId;
                        response.siteTitle = result.data.siteTitle;
                        response.logoImg = result.data.logoImg;
                        response.logoImgContentType = result.data.logoImgContentType;
                        
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();
